import React, { Component } from "react";
import { getRequest } from "../../api/ApiService";
import { logError } from "../../services/utils";
import AbbreviatedMillionNumberFormat from "../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class ResultsPanelCashFlows extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cash_flows_from_operations: {},
      cash_flows_from_investing: {},
      cash_flows_from_financing: {},
      net_change_in_cash: {},
      roundInUrl: props.roundInUrl
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  getCashflow() {
    const base_url = `${process.env.REACT_APP_API_URL}team/report/cashflow/`;
    let url = `${base_url}?round_lte=${this.props.currentRound}`;
    if (
      this.state.roundInUrl !== null &&
      this.state.roundInUrl !== this.props.currentRound
    ) {
      url = `${base_url}?round_lte=${this.state.roundInUrl}`;
    }

    return getRequest(url);
  }

  fetchData() {
    this.getCashflow()
      .then(res => {
        let cash_flows_from_operations = {};
        let cash_flows_from_investing = {};
        let cash_flows_from_financing = {};
        let net_change_in_cash = {};

        res.body.forEach(item => {
          let round_id = item.round;
          let round = this.props.rounds.find(i => i.id === round_id);
          let round_number = round.number;

          if (item["Total Cash Flows from Operations"]) {
            cash_flows_from_operations[round_number] =
              item["Total Cash Flows from Operations"];
          }

          if (item["Total Cash Flows from Investing"]) {
            cash_flows_from_investing[round_number] =
              item["Total Cash Flows from Investing"];
          }

          if (item["Total Cash Flows from Financing"]) {
            cash_flows_from_financing[round_number] =
              item["Total Cash Flows from Financing"];
          }

          if (item["Net Change in Cash"]) {
            net_change_in_cash[round_number] = item["Net Change in Cash"];
          }
        });

        this.setState({
          cash_flows_from_operations,
          cash_flows_from_investing,
          cash_flows_from_financing,
          net_change_in_cash
        });
      })
      .catch(err => {
        logError(err, "ResultsPanelCashFlows", "fetchData");
      });
  }

  componentDidMount() {
    this.fetchData();
  }

  getYear(offset) {
    const { currentRound } = this.props;
    const { roundInUrl } = this.state;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    let rounds = [current_round, current_round + 1, current_round + 2];
    if (current_round + 2 > this.props.rounds.length) {
      current_round = this.props.rounds[this.props.rounds.length - 1].number;
      rounds = [current_round - 2, current_round - 1, current_round];
    }

    return rounds[offset];
  }

  get year1() {
    return this.getYear(0);
  }

  get year2() {
    return this.getYear(1);
  }

  get year3() {
    return this.getYear(2);
  }

  getDataValue(key, year) {
    if (key in this.state) {
      let data = this.state[key];
      if (year in data) {
        return data[year];
      }
    }

    return 0;
  }

  getCashFlowsFromOperations(year) {
    return this.getDataValue("cash_flows_from_operations", year);
  }

  get cashFlowsFromOperations1() {
    return this.getCashFlowsFromOperations(this.year1);
  }

  get cashFlowsFromOperations2() {
    return this.getCashFlowsFromOperations(this.year2);
  }

  get cashFlowsFromOperations3() {
    return this.getCashFlowsFromOperations(this.year3);
  }

  getCashFlowsFromInvesting(year) {
    return this.getDataValue("cash_flows_from_investing", year);
  }

  get cashFlowsFromInvesting1() {
    return this.getCashFlowsFromInvesting(this.year1);
  }

  get cashFlowsFromInvesting2() {
    return this.getCashFlowsFromInvesting(this.year2);
  }

  get cashFlowsFromInvesting3() {
    return this.getCashFlowsFromInvesting(this.year3);
  }

  getCashFlowsFromFinancing(year) {
    return this.getDataValue("cash_flows_from_financing", year);
  }

  get cashFlowsFromFinancing1() {
    return this.getCashFlowsFromFinancing(this.year1);
  }

  get cashFlowsFromFinancing2() {
    return this.getCashFlowsFromFinancing(this.year2);
  }

  get cashFlowsFromFinancing3() {
    return this.getCashFlowsFromFinancing(this.year3);
  }

  getNetChangeInCash(year) {
    return this.getDataValue("net_change_in_cash", year);
  }

  get netChangeInCash1() {
    return this.getNetChangeInCash(this.year1);
  }

  get netChangeInCash2() {
    return this.getNetChangeInCash(this.year2);
  }

  get netChangeInCash3() {
    return this.getNetChangeInCash(this.year3);
  }

  render() {
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th className="table-title text-center">
                <span></span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year1}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year2}</span>
              </th>
              <th className="table-title text-center">
                <span>YEAR {this.year3}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <th className="text-left">Cash Flows from Operations</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromOperations1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromOperations2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromOperations3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Cash Flows from Investing</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromInvesting1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromInvesting2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromInvesting3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Cash Flows from Financing</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromFinancing1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromFinancing2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.cashFlowsFromFinancing3}
                  prefix="$"
                />
              </td>
            </tr>
            <tr className="text-center">
              <th className="text-left">Net Change in Cash</th>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netChangeInCash1}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netChangeInCash2}
                  prefix="$"
                />
              </td>
              <td>
                <AbbreviatedMillionNumberFormat
                  value={this.netChangeInCash3}
                  prefix="$"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ResultsPanelCashFlows;



// WEBPACK FOOTER //
// ./src/components/results/ResultsPanelCashFlows.js